export default {
  operationCenter: {
    expressCompany: '快递公司',
    prepaidFreight: '预付运费',
    auto_43: '支付',
    auto_44: '修改',
    auto_45: '详情',
    auto_114: '取消',
    auto_51: '审核',
    auto_84: '换入商品发货中',
    auto_86: '待支付',
    auto_90: '待审核',
    auto_93: '已退回',
    auto_96: '发货中',
    auto_100: '收货确认',
    auto_101: '待发货',
    auto_102: '发货',
    auto_103: '已发货',
    auto_105: '已完成',
    auto_106: '已取消',
    auto_33: '发送验证码',
    auto_34: '重新发送',
    auto_37: '学习机一旦标记为样机',
    auto_38: '提示',
    auto_39: '确定',
    auto_41: '采购单号调货单号',
    auto_42: '收货人',
    auto_32: '待选区',
    auto_21: '请输入码或采购单号',
    auto_22: '待选',
    auto_23: '已选',
    auto_24: '已激活',
    auto_25: '未激活',
    auto_17: '代理商名称',
    auto_18: '创建人',
    auto_19: '发货仓库',
    auto_20: '请选择发货仓库',
    auto_28: '收货地址',
    auto_29: '请输入校区地址',
    auto_30: '备注',
    auto_31: '请输入备注200字以内',
    auto_11: '商品名称',
    auto_13: '订单编号',
    auto_14: '订单商品',
    auto_15: '订单待发货数量',
    auto_1: '采购单号',
    auto_7: '收货人电话',
    auto_8: '省市区',
    auto_10: '发货状态',
    auto_107: '数量',
    auto_108: '商品',
    auto_109: '王小虎',
    auto_110: '啊是否把卡上吧狂放不',
    auto_115: '换出商品',
    auto_116: '换入商品',
    auto_117: '单价',
    auto_137: '换入',
    auto_146: '换出',
    auto_120: '总部发货',
    auto_122: '主仓',
    auto_126: '请输入码',
    auto_128: '换出商品发货',
    auto_129: '换入商品发货',
    auto_124: '返回',
    auto_118: '暂无数据',
    auto_119: '门店收货',
    auto_134: '区代发货记录导出',
    auto_135: '取消失败',
    auto_136: '销售发货导出',
    auto_132: '保费',
    auto_125: '修改失败',
    auto_131: '京东仓发货参数配置导',
    textkwso: '商品详情',
    texti5zt: '关联订单',
    textjenf: '物流详情',
    saleConsignmentDetailJdOutboundNo: '京东仓出库编号',
    saleConsignmentDetailAgentRecvWarehouse: '代理商收货仓',
    saleConsignmentDetailRemarkPh: '请输入备注，200字以内',
    saleConsignmentTraceShippingDate: '发货日期',
    saleConsignmentTraceExpressCompany: '快递公司',
    saleConsignmentTraceWayBill: '快递单号',
    saleConsignmentTraceLogisticsStatus: '物流状态',
    saleConsignmentTraceShipNum: '发货数量',
    headOfficeTransferModalTitle: '调货',
    headOfficeTransferModalAgentIdLabel: '代理商ID:',
    headOfficeTransferModalProductNameLabel: '商品名称:',
    headOfficeTransferModalPONoLabel: '采购单号/调货单号:',
    headOfficeTransferModalReceiverLabel: '收货人:',
    headOfficeTransferModalReceiverPhoneLabel: '收货人电话:',
    headOfficeTransferModalProvinceCityLabel: '所在省市:',
    headOfficeTransferModalAddressLabel: '收货地址:',
    headOfficeTransferModalOrderQtyLabel: '订购数量:',
    headOfficeTransferModalShippedQtyLabel: '已发数量:',
    headOfficeTransferModalExpressCompanyLabel: '快递公司:',
    headOfficeTransferModalSelectExpressPlaceholder: '请选择快递公司',
    headOfficeTransferModalExpressNoLabel: '快递单号:',
    headOfficeTransferModalFillExpressNo: '请填写快递单号',
    headOfficeTransferModalPendingZone: '待选区',
    headOfficeTransferModalSelectedZone: '已选区',
    headOfficeTransferModalFilterSnPurchasePlaceholder: '请输入SN码或采购单号',
  }
};
